import { useState } from 'react';
import { useServicePoints } from '../../../features/servicePoint/useServicePoints';

export const useOnSavePostClicked = (formState = {}, imageUrl) => {
    const { createServicePoint } = useServicePoints();
    const [response, setResponse] = useState();
    const [loading, setLoading] = useState(false);
    const [formPostError, setFormPostErrorr] = useState(false);

    const onSavePostClicked = async () => {

        setLoading(true);
        try {
            const formData = {
                name: formState.name,
                image: imageUrl || ' ',
                servicepoint_type_id: formState.servicepoint_type_id,
                area_id: formState.area_id,
                relevant_person: formState.relevant_person,
                address: formState.address,
                opening_time: formState.opening_time,
                closing_time: formState.closing_time,
                phone: formState.phone,
                latitude: formState.latitude,
                longitude: formState.longitude,
                client_ids: formState.client_ids,
            };
            const response = await createServicePoint(formData);
            setResponse(response);
            setFormPostErrorr(response.errors);
        } catch (error) {
            const errorResponse = error?.response?.data || { message: 'Bilinmeyen hata oluştu' };
            setResponse(errorResponse);
            return errorResponse;
        } finally {
            setLoading(false);
        }
    };

    return {
        response,
        formPostError,
        loading,
        onSavePostClicked,
    };
};
